import { Say } from "../widgets/Say";

/** a gadget that speaks Lushootseed */
export function SayLS(props: { children: string }) {
  return <Say language="Lushootseed" textColor={color}>{props.children}</Say>
}

const color = 'rgb(76,13,77)';
